/**
 * "Börja om"-markören i svarsströmmen (IM-29). Egen motor gör ett omförsök
 * när Vertex stänger strömmen tidigt utan finishReason; det påbörjade svaret
 * har då redan strömmats ut, och klienten ska byta ut det mot det nya. AI SDK:s
 * dataström kan bara lägga till text, aldrig ta bort, så servern skickar
 * markören som en egen textdel och varje konsument av svarstexten visar bara
 * det som kommer EFTER den sista markören: rendraren, källistan, betyget,
 * kopiera/exportera — och serverns egen historik för följdfrågor
 * (splitConversation i resources+/chat.ts), som får texten tillbaka från
 * klienten med markören kvar.
 *
 * Markören är U+2063 INVISIBLE SEPARATOR: osynlig om någon konsument missar
 * att klippa, och inget en modell skriver. Byggs ur kodpunkten så att tecknet
 * aldrig ligger rått (osynligt) i källkoden. Klientsäker modul — inga imports.
 */
export const ANSWER_RESTART = String.fromCodePoint(0x2063)

/** Texten efter den sista "börja om"-markören; hela texten om ingen finns. */
export function visibleAnswerText(text: string): string {
	const i = text.lastIndexOf(ANSWER_RESTART)
	return i === -1 ? text : text.slice(i + 1)
}
